import React, {Component} from 'react'
import Helmet from 'react-helmet'
import Elm from 'react-elm-components'
import ElmMain from '../../elm/src/QualificationCriteriaTree.elm'
import './QualificationCriteriaEdit.less'
import i18n from '../i18n'
import config from '../config'
import {connect} from 'react-redux'
import {errorStatus} from '../core/redux/status'

const getRandomInts = (n) => {
    const randInts = new Uint32Array(n)
    crypto.getRandomValues(randInts)
    return Array.from(randInts)
}

class QualificationCriteriaTree extends Component {
    setupPorts = (ports) => {
        const {dispatch} = this.props
        ports.sendErrorToRedux.subscribe(e => {
            dispatch(errorStatus(e))
        })
    }

    render() {
        const randInts = getRandomInts(5)

        const apiEvent = config.api.event.url
        const apiUrl = config.api.url
        const links = this.props.company.company._links

        const flags =
            { clientCompany: this.props.company.company.uid
            , seedInfos: [randInts[0], randInts.slice(1)]
            , apiEvent
            , apiUrl
            , navigationLinks: links
            }

        return (
            <div className={"decisionTree"}>
                <Helmet title={i18n.qualifCriterias} />
                <Elm src={ElmMain.Elm.QualificationCriteriaTree} flags={flags} ports={this.setupPorts}/>
            </div>
        )
    }
}

export default connect(({company}) => ({company}))(QualificationCriteriaTree)


// WEBPACK FOOTER //
// ./lib/qualificationCriteria/QualificationCriteriaTree.js